import React from 'react';
import { LabelIcon } from '@weezevent/nacre';
import css from '../../styles.module.css';
import { useTranslation } from 'react-i18next';
import { useInterval } from '../../../../../components/export/exportButton';

export default function Timer({ details, validityTimer = 900, form, onTimerReached = null }) {
    const { t } = useTranslation();
    const [remainingTime, setRemainingTime] = React.useState(validityTimer);
    const [delay, setDelay] = React.useState(1000);

    const cartTimer = React.useMemo(() => {
        if (remainingTime === 0) {
            return `00:00`;
        }
        return `${Math.floor(remainingTime / 60)}:${remainingTime % 60}`;
    }, [remainingTime]);

    const isNearExpired = React.useMemo(() => {
        return remainingTime <= 120 && remainingTime >= 1;
    }, [remainingTime]);

    const decrementTimer = React.useCallback(() => {
        setRemainingTime(time => {
            let remain = time - 1;
            if (remain === 0) {
                onTimerReached?.();
                setDelay(null);
            }
            return remain;
        });
    }, [onTimerReached]);

    useInterval(decrementTimer, delay);

    React.useEffect(() => {
        if (form) {
            // form has changed, so we clear timer
            setRemainingTime(validityTimer);
        }
    }, [form, validityTimer]);

    const timer = details || isNearExpired ? cartTimer.padEnd(4, '0') : parseInt(cartTimer);
    let text = `${t('attendees.addAttendees.summary.timer')} ${timer}`;
    let label = details || isNearExpired ? text : `${text} MIN`;

    return (
        <>
            <LabelIcon
                className={!isNearExpired ? css['timer-label'] : css['timer-countdown']}
                active
                label={remainingTime > 0 ? label : t('attendees.addAttendees.summary.expired')}
                left
                inverted
                nameIcon="time"
            />
        </>
    );
}
